import {
    FETCH_PRICE_GROUPS_LIST_REQUEST,
    FETCH_PRICE_GROUPS_LIST_SUCCESS,
    FETCH_PRICE_GROUPS_LIST_FAILURE,
  } from "./FetchPriceGroupListTypes";
  
  const initialState = {
    loading: false,
    pricegroupsList: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PRICE_GROUPS_LIST_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_PRICE_GROUPS_LIST_SUCCESS:
        return {
          loading: false,
          pricegroupsList: action.payload,
          error: "",
        };
      case FETCH_PRICE_GROUPS_LIST_FAILURE:
        return {
          loading: false,
          pricegroupsList: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  